(function() {
    'use strict';

    angular.module('page', [
            'ui.router',

            'page.constants',
            'page.services'
        ])
        .config(uiRouting);

    uiRouting.$inject = ['$stateProvider', 'userPermissionsConst', 'pagePermissionsConst'];

    function uiRouting($stateProvider, userPermissionsConst, pagePermissionsConst) {
        $stateProvider
            .state('layout.page', {
                abstract: true,
                url: '/pages',
                data: {
                    title: 'Strony',
                    permission: userPermissionsConst.user
                }
            })
            .state('layout.page.list', {
                url: '/list',
                views: {
                    'main@layout': {
                        templateUrl: 'app/page/views/page-list/page-list.html',
                        controller: 'PageListController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: pagePermissionsConst.view
                }
            })
            .state('layout.page.create', {
                url: '/create?parent',
                views: {
                    'main@layout': {
                        templateUrl: 'app/page/views/page-create/page-create.html',
                        controller: 'PageCreateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: pagePermissionsConst.add
                }
            })
            .state('layout.page.update', {
                url: '/update/:pk',
                views: {
                    'main@layout': {
                        templateUrl: 'app/page/views/page-update/page-update.html',
                        controller: 'PageUpdateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: pagePermissionsConst.update
                }
            });
    }
})();
